var React = require('react');

function Star (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_6_77)","key":0},React.createElement("path",{"d":"M23 0L28.3883 16.5836H45.8254L31.7185 26.8328L37.1068 43.4164L23 33.1672L8.89315 43.4164L14.2815 26.8328L0.174644 16.5836H17.6117L23 0Z","fill":"#F8B22C"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_6_77"},React.createElement("rect",{"width":"50","height":"50","fill":"white"})))]);
}

Star.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = Star;

Star.default = Star;
